import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { state } from '../../store';
import { withRouter } from 'react-router-dom';
import { PieChart } from './pie-chart';
// import { SpendPatternChart } from './timeseries-chart';
import ErrorPage from '../../components-library/error-page';
import { appSelector } from '../../app/store';

import { sellerDashboardSelector, sellerDashboardActions } from './store';
export const SellerDashboardPage = withRouter(
  connect(
    state.select({
      data: sellerDashboardSelector((state) => state.data, {}),
      loading: sellerDashboardSelector((state) => state.loading),
      error: appSelector((state) => state.error),
    }),
    state.actions(sellerDashboardActions, ['loadDashboardData']),
  )(
    class SellerDashboardPage extends PureComponent {
      // eslint-disable-next-line camelcase
      UNSAFE_componentWillMount() {
        const { query } = this.props;
        let id = query.get('id');
        this.props.loadDashboardData(id);
      }
      getTimeline = (timeline) => {
        let fixedTimeline = null;
        if (parseInt(timeline) === 1) {
          fixedTimeline = `${timeline} day`;
        } else if (parseInt(timeline) > 1) {
          fixedTimeline = `${timeline} days`;
        } else {
          fixedTimeline = 'ASAP';
        }
        return fixedTimeline;
      };
      render() {
        const { loading, error, data, history } = this.props;
        if (loading) {
          return (
            <>
              <div className="header">
                <div className="container-fluid">
                  <div className="header-body" style={{ border: '0px' }}>
                    <div className="row align-items-end">
                      <div className="col">
                        <h1 className="header-title">Dashboard</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section className="container page-content pb-6 market-content text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </section>
            </>
          );
        }
        if (error) {
          return <ErrorPage error={error} />;
        }
        return (
          <>
            <div className="header mb-1">
              <div className="container-fluid">
                <div className="header-body" style={{ border: '0px' }}>
                  <div className="row align-items-end">
                    <div className="col">
                      <h1 className="header-title">Dashboard</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid d-flex flex-column">
              <div className="row">
                <div className="col-12 col-md-6 col-xl-6 d-flex flex-column">
                  <div className="card  h-50">
                    <div className="card-body p-md-1 d-flex align-items-center justify-content-center">
                      <div className="row align-items-center text-center">
                        <div className="col">
                          <h6 className="text-uppercase h4 text-muted mb-2">Total Won</h6>
                          <span className="h1 mb-0">${data.marketWon}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card h-50">
                    <div className="card-body p-md-1 d-flex align-items-center justify-content-center">
                      <div className="row align-items-center text-center">
                        <div className="col">
                          <h6 className="text-uppercase h4 text-muted mb-2">Total Quoted</h6>
                          <span className="h1 mb-0">${data.marketQuoted}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 h-50 col-md-6 col-xl-6">
                  <div className="card h-75">
                    <div className="card-header p-0 pl-3">
                      <h4 className="card-header-title">Product Types Sold</h4>
                    </div>
                    <div className="card-body p-1">
                      <PieChart data={data.productTypesSold} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-12 col-md-6 col-xl-6">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-header-title">Score Over Time</h4>
                    </div>
                    <div className="card-body"></div>
                  </div>
                </div> */}
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-header-title">Most Recent Request For Quotes</h4>
                    </div>
                    <div className="card-body pt-0 pr-0">
                      <div className="table-responsive table-dashboard">
                        <table className="table  table-sm table-hover table-nowrap card-table">
                          <thead>
                            <tr>
                              <th>
                                <span className="text-muted">Product</span>
                              </th>
                              <th>
                                <span className="text-muted">Quantity</span>
                              </th>
                              <th>
                                <span className="text-muted">Price Per Unit</span>
                              </th>
                              <th>
                                <span className="text-muted">Opportunity</span>
                              </th>
                              <th>
                                <span className="text-muted">Needed By</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="list font-size-base">
                            {data.rfqs && data.rfqs.length ? (
                              data.rfqs.map((item, index) => {
                                return (
                                  <tr
                                    className="cursorTospan"
                                    key={index}
                                    onClick={() => {
                                      history.push(
                                        `rfq-details?id=${data.sellerId}&hotlineId=${item.id}&status=active`,
                                      );
                                    }}
                                  >
                                    <td className="tables-row">{item['Product Type']}</td>
                                    <td className="tables-row">{item.Quantity}</td>
                                    <td style={{ paddingLeft: '1.55rem' }} className="tables-row">
                                      ${item['Max Price Per Product Unit']}
                                    </td>
                                    <td className="tables-row">${item['Revenue Opportunity']}</td>
                                    <td className="tables-row">{this.getTimeline(item['Timing (days)'])}</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td className="tables-row" colSpan="5">
                                  <div className="col ml-n2">
                                    <h4 className="mb-1 text-center">No Recent RFQs Found</h4>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      }
    },
  ),
);
